<template lang="pug">
  validation-observer(ref="obs" v-slot="{ invalid }")
    .text-h6.d-block.secondary--text.font-weight-bold.mb-2.pa-2 Вход в систему
    v-window(v-model="window")
      v-window-item.pa-2
        v-list-item.sdo-radius.sdo-shadow.py-2.px-5.mb-4(
          link
          @click="getVkAuth"
        )
          v-list-item-avatar.mr-8(color="#0077ff" size="70")
            v-icon( size="44" color="white") $vk
          v-list-item-content
            v-list-item-title.text-h6.secondary--text.pr-8: strong Вход через Вконтакте
            v-list-item-subtitle.caption или регистрация
          v-list-item-action: v-icon(color="primary") mdi-chevron-right
        v-list-item.sdo-radius.sdo-shadow.py-2.px-5(
          link
          @click="getTelegramAuth"
        )
          v-list-item-avatar.mr-8(color="info" size="70")
            v-icon( size="70" color="white ").pl-3.pt-1 $telegram
          v-list-item-content
            v-list-item-title.text-h6.secondary--text.pr-8: strong Вход через Telegram
            v-list-item-subtitle.caption или регистрация
          v-list-item-action: v-icon(color="primary") mdi-chevron-right

        .text-end.text-body-2.mt-4
          v-btn(
            text small
            color="grey darken-1"
            @click="window = 1"
          ) Войти другим способом
      v-window-item.pa-2.pt-0
        v-btn(fab small depressed @click="window=0").mb-6: v-icon(size="18") mdi-arrow-left
        .text-caption.ml-2.mb-2.text-center.align-center.d-flex
          v-icon.mr-2(size="18" color="secondary") mdi-information-outline
          span Можно использовать логин и пароль
          a.ml-1.text-decoration-none(href="pfdo.ru") ПФДО
        v-form(ref="form")
          validation-provider(
            rules="required"
            name="Имя пользователя"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="username"
              ref="username"
              name="username"
              label="Имя пользователя"
              @keyup.enter="login"
              :error-messages="errors"
              filled
              rounded
            )
          validation-provider(
            rules="required"
            name="Пароль"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="password"
              name="password"
              ref="password"
              @keyup.enter="login"
              label="Пароль"
              :error-messages="errors"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              filled
              rounded
            )
        .d-flex.mb-2
          v-btn.px-5.ml-auto(
            text
            rounded color="primary" small
            @click="openResetPasswordDialog"
          ) Восстановить пароль
        v-btn(
          color="success"
          class="text-uppercase"
          @click="login"
          :loading="loadingBtn"
          depressed block large
          rounded
        ) Войти
        .text-body-2.mb-6.pl-2.text-center.mt-2
          span Еще нет аккаунта?
          router-link.ml-1.text-decoration-none(:to="{ name: 'SignUp' }") Зарегистрироваться

          //-   v-btn.mt-4(
          //-   outlined
          //-   rounded
          //-   large
          //-   color="primary"
          //-   @click="getTelegramAuth"
          //- )
          //-   | Войти через телеграм

          //- v-switch(v-model="localLogin" label="Войти локально" hide-details)

</template>

<script>
import { mapActions } from 'vuex';
import ResetPasswordModal from './ResetPasswordModal.vue';

export default {
  name: 'SignInForm',
  props: {
    redirect: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    window: 0,
    username: '',
    password: '',
    showPassword: false,
    loadingBtn: false,
    // localLogin: false,
  }),
  methods: {
    async getTelegramAuth() {
      const { data } = await this.$api.auth.getTelegramAuth();
      const { uri } = data.data;
      window.location.href = uri;
    },
    async getVkAuth() {
      const { data } = await this.$api.auth.getVkAuth();
      const { uri } = data.data;
      window.location.href = uri;
    },
    openResetPasswordDialog() {
      this.$modals.show('generic-controller', {
        title: 'Восстановление пароля',
        component: ResetPasswordModal,
        dialogProps: {
          'max-width': 700,
        },
      });
    },
    ...mapActions({ AUTHENTICATE: 'auth/AUTHENTICATE' }),
    login() {
      this.loadingBtn = true;
      const loginData = {
        username: this.username,
        password: this.password,
        // isLocal: this.localLogin,
      };
      this.AUTHENTICATE(loginData)
        .then(() => {
          this.loadingBtn = false;

          if (this.redirect) {
            this.$router.push(this.redirect);
            return;
          }
          this.$router.push({ name: 'Desktop' });
        })
        .catch(() => {
          this.loadingBtn = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
